"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _superagent = _interopRequireDefault(require("superagent"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * AddressService is responsible for returning possible matching addresses based on user queries
 */
var AddressService = /*#__PURE__*/function () {
  function AddressService() {
    _classCallCheck(this, AddressService);
  }

  _createClass(AddressService, null, [{
    key: "getMatchingAddresses",

    /**
     * Base API Url for address services
     * @type {string}
     */

    /**
     * Base API Url for reference data
     * @type {string}
     */

    /**
     * getMatchingAddresses returns an object with the number of matching addresses and an array of address objects as follows:
     * {
     *   type: 'Address',
     *   id: 'AUS|0ba493ff-d865-431b-8c68-8d4d114858f9|0MOAUSHArhBwAAAAAIAwEAAAAAZrvnkAAgAAAAAAAAAAD..2QAAAAA.....wAAAAAAAAAAAAAAAAAiMzA5IGtlbnQgc3QiAA--',
     *   attributes: {
     *     addressLine: '309 Kent Street, SYDNEY  NSW  2000'
     *   },
     *   links: {
     *     self: 'https://dev.api-nonprod.icare.nsw.gov.au/v1/customer/addresses?id=AUS|0ba493ff-d865-431b-8c68-8d4d114858f9|0MOAUSHArhBwAAAAAIAwEAAAAAZrvnkAAgAAAAAAAAAAD..2QAAAAA.....wAAAAAAAAAAAAAAAAAiMzA5IGtlbnQgc3QiAA--'
     *   }
     * }
     *
     * The addressLine is displayed to the user
     * The id is used in the getStructuredAddress below to get the structured address
     *
     * @param {string} addressString - the string you want to query addresses against
     */
    value: function () {
      var _getMatchingAddresses = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(addressString) {
        var endpoint, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (addressString) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", {
                  count: 0,
                  results: []
                });

              case 2:
                /**
                 * Backup of previous endpoint
                 * const EXPERIAN_BASE = 'https://api.edq.com';
                 * const endpoint = `${EXPERIAN_BASE}/capture/address/v2/search/`;
                 */
                endpoint = "".concat(_.globalConfig.addressService.baseApiUrl, "/v2/portal/addresses/search");
                _context.next = 5;
                return _superagent.default.get(endpoint).query({
                  query: addressString,
                  size: 60,
                  offset: 0,
                  pageSize: 1000
                });

              case 5:
                response = _context.sent;
                return _context.abrupt("return", response.body);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getMatchingAddresses(_x) {
        return _getMatchingAddresses.apply(this, arguments);
      }

      return getMatchingAddresses;
    }()
    /**
     * getStructuredAddress uses the address id returned by getMatchingAddresses to return
     * an object version of an address as follows
     * {
     *   "data": {
     *     "type": "Address",
     *     "id": "762AUS-VOAUSHAnhBwAAAAAIAgEAAAAAkzURwAAAAAAAAAAA..9kAAAAAP....8AAAAAAAAAAAAAAAAAAABhYmMA",
     *     "attributes": {
     *       "addressLine1": "ABC",
     *       "addressLine2": "246-250 Riverside Bvd",
     *       "addressLine3": null,
     *       "postalDeliveryNumberValue": "64349266",
     *       "flatOrUnitNumber": null,
     *       "floorOrLevelNumber": null,
     *       "houseNumber": null,
     *       "buildingOrPropertyName": "ABC",
     *       "buildingNumber": "246-250",
     *       "lotNumber": null,
     *       "streetName": "Riverside Bvd",
     *       "suburbOrPlaceOrLocality": null,
     *       "stateOrTerritory": "Queensland",
     *       "stateOrTerritoryCode": "QLD",
     *       "postCode": "4814",
     *       "country": "AUSTRALIA",
     *       "countryISO": "AUS",
     *       "location": null
     *     }
     *   }
     * }
     * @param {string} endpoint - the address id to call to receive a structured address
     */

  }, {
    key: "getStructuredAddress",
    value: function () {
      var _getStructuredAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(addressId) {
        var endpoint, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = "".concat(_.globalConfig.addressService.baseApiUrl, "/v2/portal/addresses");
                _context2.next = 3;
                return _superagent.default.get("".concat(endpoint, "?id=").concat(addressId)) // addressId is already a URI component
                .query({
                  offset: 1,
                  pageSize: 1000
                });

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.body);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getStructuredAddress(_x2) {
        return _getStructuredAddress.apply(this, arguments);
      }

      return getStructuredAddress;
    }()
    /**
     * getCountryList returns the list of all countries in an object
     */

  }, {
    key: "getCountryList",
    value: function () {
      var _getCountryList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var endpoint, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                endpoint = "".concat(_.globalConfig.addressService.referenceDataApiBaseUrl, "/v1/referenceData/countries?namespace=ICARE");
                _context3.next = 3;
                return _superagent.default.get(endpoint);

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", response.body);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getCountryList() {
        return _getCountryList.apply(this, arguments);
      }

      return getCountryList;
    }()
    /**
     * getStateList returns the list of all Australia states in an object
     */

  }, {
    key: "getStateList",
    value: function () {
      var _getStateList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var endpoint, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = "".concat(_.globalConfig.addressService.referenceDataApiBaseUrl, "/v1/referenceData/states?countryName=AUSTRALIA&namespace=ICARE");
                _context4.next = 3;
                return _superagent.default.get(endpoint);

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", response.body);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getStateList() {
        return _getStateList.apply(this, arguments);
      }

      return getStateList;
    }()
  }]);

  return AddressService;
}();

exports.default = AddressService;

_defineProperty(AddressService, "baseApiUrl", '');

_defineProperty(AddressService, "referenceDataApiBaseUrl", '');
//# sourceMappingURL=AddressService.js.map